import useSeo from "@/lib/useSeo";
import PageHero from "@/components/site/PageHero";
import FAQ from "@/components/sections/FAQ";
import CtaBanner from "@/components/site/CtaBanner";

export default function FAQPage() {
    useSeo({
        title: "FAQ – Häufige Fragen zur Reinigung in Innsbruck",
        description:
            "Antworten auf häufige Fragen zu Gebäudereinigung, Fensterreinigung, Fassadenreinigung und Spezialreinigung in Innsbruck und Tirol.",
        path: "/faq",
    });
    return (
        <div>
            <PageHero
                eyebrow="FAQ"
                title="Häufige Fragen zur Reinigung in Innsbruck"
                lead="Sie haben eine Frage zu unseren Reinigungsleistungen? Hier finden Sie die wichtigsten Antworten kompakt zusammengefasst."
                breadcrumbs={[{ label: "FAQ" }]}
            />
            <FAQ />
            <CtaBanner title="Frage nicht beantwortet?" subtitle="Rufen Sie uns kurz an oder schreiben Sie uns – wir helfen schnell weiter." />
        </div>
    );
}
